<template>
  <div class="home-page">
    <h1>密钥分享服务</h1>
    <p>这是一个用于分享加密密钥和文字内容的服务。</p>
    
    <div class="features">
      <div class="feature-card">
        <h2>密钥分享</h2>
        <p>使用微信小程序生成密钥分享链接。</p>
      </div>
      
      <div class="feature-card">
        <h2>文字分享</h2>
        <p>分享文字内容给您的朋友。</p>
        <router-link to="/share" class="btn btn-primary">开始分享文字</router-link>
      </div>
      
      <div class="feature-card">
        <h2>功能测试</h2>
        <p>测试加密和解密功能。</p>
        <router-link to="/test" class="btn btn-secondary">进入测试页面</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>

<style scoped>
.home-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

h1 {
  color: #07C160;
  margin-bottom: 20px;
}

p {
  color: #666;
  line-height: 1.6;
}

.features {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-top: 40px;
}

.feature-card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 350px;
  text-align: center;
}

.feature-card h2 {
  color: #07C160;
  margin-bottom: 15px;
}

.feature-card p {
  margin-bottom: 20px;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
}

.btn-primary {
  background-color: #07C160;
  color: white;
}

.btn-primary:hover {
  background-color: #06a050;
}

.btn-secondary {
  background-color: #2c8af8;
  color: white;
}

.btn-secondary:hover {
  background-color: #1a7ae0;
}
</style>
